import { IDict } from "./types";

export const fr: IDict = {
  Jobs: "Travaux",
  "No Jobs": "Pas de Travaux",
  Billing: "Facturation",
  Credits: "Crédits",
  "Pay Per Use": "Pay Per Use",
  "Feature Voting": "Vote des Fonctionnalités",
  "Free Karaoke Left": "Karaoké Gratuit Restant",
  "Upgrade Now to Create More": "Mettez à Jour Maintenant pour en Créer Plus",
  "Storage is Full": "Stockage plein",
  "Youka is running out of storage space": "Youka manque d'espace de stockage",
  "Please free up at least 1 GB before creating new karaoke":
    "Veuillez libérer au moins 1 Go avant de créer un nouveau karaoké",
  "Click the button to check again":
    "Cliquez sur le bouton pour vérifier à nouveau",
  "No Internet Connection": "Pas de connexion Internet",
  "Youka cannot connect to the internet":
    "Youka ne peut pas se connecter à Internet",
  "Please make sure you have internet connection":
    "Veuillez vous assurer que vous avez une connexion Internet",
  "Update is ready": "La mise à jour est prête",
  "Click the button to update": "Cliquez sur le bouton pour mettre à jour",
  "Library Folder": "Dossier de la Bibliothèque",
  "Export Folder": "Dossier d'Exportation",
  "Sync Model": "Modèle de Synchronisation",
  "Max Video Quality": "Qualité Vidéo Maximale",
  "Speed / Compression Preset": "Préréglage Vitesse / Compression",
  Change: "Changer",
  "dialogs.upgrade.upgrade_to_pro":
    "La fonctionnalité que vous recherchez fait partie du plan Pro, effectuez la mise à niveau maintenant pour débloquer cette fonctionnalité.",
  "dialogs.upgrade.upgrade_to_standard":
    "La fonctionnalité que vous recherchez fait partie du forfait Standard, effectuez la mise à niveau maintenant pour débloquer cette fonctionnalité.",
  heads_up: "Attention!",
  "dialogs.edit_lyrics.not_supported":
    "La langue que vous avez choisie n'est actuellement pas prise en charge pour la synchronisation automatique des paroles. Cependant, vous pouvez enregistrer votre progression, puis utiliser l'éditeur de niveau de ligne pour synchroniser les paroles manuellement.",
  "dialogs.create.title": "Créer un nouveau karaoké",
  "dialogs.create.description":
    "Veuillez remplir le formulaire ci-dessous pour créer un nouveau karaoké, vous pouvez utiliser un fichier audio ou vidéo, les paroles sont facultatives.",
  "dialogs.edit_lyrics.description":
    "Après l'enregistrement, le processus de synchronisation démarrera, vous pourrez suivre la progression dans l'onglet Jobs",
  "dialogs.upgrade.see_plans": "Voir les Plans",
  "dialogs.upgrade.unlock": "Débloquer",
  "comps.sync_editor.attach_previous": "Attacher au mot précédent",
  "comps.sync_editor.attach_next": "Attacher au mot suivant",
  "comps.plans.title":
    "Choisissez le plan qui correspond le mieux à vos besoins. Vous pouvez toujours améliorer ou réduire votre plan",
  "Font Size": "Taille de Police",
  Spacing: "Espacement",
  Outline: "Contour",
  "Margin Bottom": "Marge Inférieure",
  "Max Chars per Line": "Max Caractères par Ligne",
  Bold: "Gras",
  Italic: "Italique",
  Shadow: "Ombre",
  month: "mois",
  songs: "chansons",
  Title: "Titre",
  "Save and Sync": "Sauvegarder et Synchroniser",
  Lyrics: "Paroles",
  Update: "Mettre à Jour",
  Playlist: "Playlist",
  Canceling: "Annulation",
  Play: "Jouer",
  "Lyrics Language": "Langue des Paroles",
  "Background Image": "Image de Fond",
  "Basic Version": "Version Basique",
  "Standard Version": "Version Standard",
  "Pro Version": "Version Pro",
  "Trial Version": "Version d'Essai",
  "No Active Plan": "Aucun Plan Actif",
  "Days Left in Trial": "Jours Restants dans l'Essai",
  Paste: "Coller",
  "Sync Lyrics": "Synchroniser les Paroles",
  Show: "Afficher",
  Settings: "Paramètres",
  Retry: "Réessayer",
  "Create Karaoke": "Créer un Karaoké",
  Canceled: "Annulé",
  Reset: "Réinitialiser",
  "Edit Video": "Éditer la Vidéo",
  Download: "Télécharger",
  "Edit Metadata": "Éditer les Métadonnées",
  "Subtitle Designer": "Concepteur de Sous-titres",
  Export: "Exporter",
  year: "année",
  Basic: "Basique",
  Standard: "Standard",
  Pro: "Pro",
  Accept: "Accepter",
  "Add new word": "Ajouter un nouveau mot",
  "Add to queue": "Ajouter à la file d'attente",
  "An unknown error occurred": "Une erreur inconnue s'est produite",
  Annually: "Annuellement",
  "Are you sure you want to delete this karaoke song?":
    "Êtes-vous sûr de vouloir supprimer cette chanson de karaoké?",
  "Artist Name": "Nom de l'Artiste",
  "Audio or Video File": "Fichier Audio ou Vidéo",
  Audio: "Audio",
  "Auto Karaoke Generator": "Générateur de Karaoké Automatique",
  "Auto Lyrics Sync": "Synchronisation Automatique des Paroles",
  "Cancel Plan": "Annuler le Plan",
  Cancel: "Annuler",
  Close: "Fermer",
  "Create Karaoke from song": "Créer un Karaoké à partir de la Chanson",
  "Create Karaoke from local files":
    "Créer un Karaoké à partir de fichiers locaux",
  "Create new karaoke": "Créer un nouveau karaoké",
  Create: "Créer",
  "Current Plan": "Plan Actuel",
  "Dark Mode": "Mode Sombre",
  Decline: "Décliner",
  "Delete word": "Supprimer le mot",
  Delete: "Supprimer",
  "Edit Lyrics": "Éditer les Paroles",
  Edit: "Éditer",
  "Export to mp3/mp4": "Exporter en mp3/mp4",
  "Go Back to EULA": "Retourner à l'EULA",
  "Go back": "Retour",
  "Go forward": "Avancer",
  Home: "Accueil",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "J'accepte les termes et m'engage à éviter l'utilisation non autorisée de contenu protégé par des droits d'auteur",
  Instruments: "Instruments",
  Key: "Tonalité",
  Library: "Bibliothèque",
  "Light Mode": "Mode Clair",
  "Line Level Sync": "Synchronisation au Niveau de la Ligne",
  "Line Level": "Niveau de Ligne",
  "Lyrics (optional)": "Paroles (facultatif)",
  "Lyrics Sync Editor": "Éditeur de Synchronisation des Paroles",
  Manage: "Gérer",
  Monthly: "Mensuel",
  "Most popular": "Le plus populaire",
  "No new notifications": "Pas de nouvelles notifications",
  "No results": "Aucun résultat",
  "No songs in library": "Aucune chanson dans la bibliothèque",
  "No songs in queue": "Aucune chanson dans la file d'attente",
  Notifications: "Notifications",
  Off: "Désactivé",
  Or: "Ou",
  "Plan canceled, will end in": "Plan annulé, se terminera dans",
  "Play word in loop": "Jouer le mot en boucle",
  "Preparing Youka": "Préparation de Youka",
  "Process 2 karaokes at a time": "Traiter 2 karaokés à la fois",
  "Process 5 karaokes at a time": "Traiter 5 karaokés à la fois",
  Queue: "File d'attente",
  Ready: "Prêt",
  "Remove from queue": "Retirer de la file d'attente",
  "Resume plan": "Reprendre le plan",
  "Save and Resync": "Sauvegarder et Resynchroniser",
  Save: "Sauvegarder",
  "Saving...": "Sauvegarde en cours...",
  Search: "Rechercher",
  "Select plan": "Sélectionner un plan",
  "Sign In": "Se Connecter",
  "Sign Out": "Se Déconnecter",
  "Sign Up": "S'Inscrire",
  "Song Name": "Nom de la Chanson",
  "Start typing to search or paste YouTube URL":
    "Commencez à taper pour rechercher ou collez l'URL YouTube",
  "Start typing to search": "Commencez à taper pour rechercher",
  "Subtitle Track": "Piste de Sous-titres",
  Subtitles: "Sous-titres",
  Tempo: "Tempo",
  "Terms and Conditions": "Termes et Conditions",
  "This action cannot be undone.": "Cette action ne peut pas être annulée.",
  "Thumbnail URL": "URL de la Miniature",
  "To keep the karaoke fun going, please upgrade":
    "Pour continuer à profiter du karaoké, veuillez mettre à jour",
  "Unlock Premium Features with an Upgrade!":
    "Débloquez les Fonctionnalités Premium avec une Mise à Jour!",
  "Update Payment Method": "Mettre à Jour le Moyen de Paiement",
  "Upgrade to Pro plan to enable": "Mettez à jour au plan Pro pour activer",
  Upgrade: "Mise à Jour",
  Version: "Version",
  Video: "Vidéo",
  Vocals: "Voix",
  "Waiting in queue": "En attente dans la file",
  "Word Level Sync": "Synchronisation au Niveau du Mot",
  "Word Level": "Niveau du Mot",
  "You need to accept the EULA to use Youka":
    "Vous devez accepter l'EULA pour utiliser Youka",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "Vos paroles ont été sauvegardées avec succès. Une resynchronisation est en cours. Vous pouvez suivre la progression dans la zone de notification. Une fois la resynchronisation terminée, vous pourrez voir les modifications - il suffit d'appuyer sur 'jouer'.",
  "Your trial version of Youka has expired":
    "Votre version d'essai de Youka a expiré",
  "dialogs.youtube.title":
    "Installez le plugin yt-dlp pour rechercher et lire des vidéos en ligne",
  "dialogs.youtube.description":
    "Veuillez lire et accepter les avertissements suivants avant d'activer le plugin.",
  "dialogs.youtube.agree": "J'ai lu et compris les avertissements ci-dessus",
  "dialogs.youtube.install": "Installer le Plugin",
  "dialogs.youtube.install_success": "Plugin installé avec succès",
  "dialogs.youtube.install_success_description":
    "Vous pouvez maintenant rechercher et lire des vidéos en ligne",
  "dialogs.youtube.install_error": "Échec de l'installation du Plugin",
  "alert.youtube.description":
    "Le Plugin de Recherche et Téléchargement de Vidéos en Ligne (yt-dlp) n'est pas préinstallé. Cliquez pour installer le plugin.",
  "alert.youtube.install": "Installer le Plugin",
  "dialogs.settings.enable_youtube": "Activer le Plugin yt-dlp",
  "dialogs.youtube.warnings": [
    {
      title: "Conformité Légale",
      description:
        "Assurez-vous que votre utilisation de ce plugin est en pleine conformité avec toutes les lois applicables et les conditions d'utilisation de toutes les plateformes avec lesquelles vous interagissez, comme YouTube.",
    },
    {
      title: "Droit d'Auteur et Licences",
      description:
        "Ce plugin peut permettre des actions (comme le téléchargement de contenu) qui pourraient enfreindre les lois sur le droit d'auteur ou violer les accords de licence s'il n'est pas utilisé correctement. Il est crucial de respecter les droits des créateurs de contenu et d'utiliser le plugin uniquement à des fins légalement autorisées.",
    },
    {
      title: "Aucun Endossement",
      description:
        "L'activation de ce plugin n'implique pas l'endossement ou le soutien de notre entreprise. Le plugin est une entité séparée et nous ne sommes pas responsables de son fonctionnement ni des conséquences de son utilisation.",
    },
    {
      title: "Responsabilité de l'Utilisateur",
      description:
        "Vous êtes seul responsable de toutes les actions que vous entreprenez en utilisant ce plugin. Cela inclut toutes les conséquences légales qui peuvent survenir en raison d'une mauvaise utilisation ou d'une violation des conditions d'utilisation.",
    },
    {
      title: "Risques Potentiels",
      description:
        "Soyez conscient que la mauvaise utilisation du plugin pourrait entraîner la suspension de votre compte ou des actions en justice par les parties affectées ou les plateformes.",
    },
    {
      title: "Consentement Éclairé",
      description:
        "En procédant à l'activation de ce plugin, vous reconnaissez avoir lu et compris ces avertissements et acceptez l'entière responsabilité de votre utilisation du plugin.",
    },
  ],

  "model.auto": "Sélectionner automatiquement le meilleur modèle.",
  "model.audioshake.transcription":
    "Le 1er meilleur modèle, qui implique la transcription puis l'alignement, fournit des résultats supérieurs mais est accessible exclusivement aux utilisateurs Pay Per Use et Trial (prenant jusqu'à 10 minutes).",
  "model.audioshake":
    "Le deuxième meilleur modèle correspond aux paroles fournies, où les inexactitudes peuvent conduire à des résultats sous-optimaux (prenant jusqu'à 10 minutes).",
  "model.wav2vec2":
    "Le 3ème meilleur modèle, s'aligne sur les paroles fournies, où les inexactitudes peuvent conduire à des résultats sous-optimaux, prend en charge presque toutes les langues. (cela prend jusqu'à 30 secondes)",
  "model.whisper":
    "Le 4ème meilleur modèle, qui consiste à transcrire puis à aligner. Les paroles de sortie peuvent ne pas être exactes, bien que la synchronisation soit acceptable (prenant jusqu'à 2 minutes).",
  "sync.line.instructions": [
    "Cliquez sur le bouton Play pour lire la chanson et démarrer le processus de synchronisation",
    "Cliquez sur le bouton Set Start lorsque vous entendez le premier mot de la ligne en cours",
    "Cliquez sur le bouton Définir la fin après avoir entendu le dernier mot de la ligne en cours",
    "Continuez jusqu'à ce que vous ayez fini de synchroniser toutes les lignes",
  ],
  Undo: "Annuler",
  Redo: "Refaire",
  "Set Start": "Définir le Début",
  "Set End": "Définir la Fin",
  "dialogs.edit_lyrics.transcription":
    "Lors de l'utilisation du modèle de transcription, le modèle transcrit indépendamment la chanson et identifie les paroles par lui-même, sans s'appuyer sur les paroles fournies. Ensuite, vous avez la possibilité d'ajuster les paroles à l'aide de l'outil de synchronisation.",
  "Duet Editor": "Éditeur de Duo",
  "Manual Line Sync": "Synchronisation Manuelle de Ligne",
  "New Style": "Nouveau Style",
  Style: "Style",
  Singer: "Chanteur",
  "Style Editor": "Éditeur de Style",
  Word: "Mot",
  Line: "Ligne",
  "Split Line": "Diviser la Ligne",
  "Upgrade to Enable": "Mettre à Niveau pour Activer",
  upgrade_description:
    "Vous avez la possibilité d'écouter ou de télécharger les pistes de karaoké que vous avez déjà générées. Toutefois, si vous souhaitez créer des pistes de karaoké supplémentaires, une mise à niveau est requise.",
  "dialogs.global.no_user.title": "Aucun plan actif",
  "dialogs.global.no_user.description":
    "Veuillez passer à un plan pour continuer.",
  "dialogs.global.no_role.title": "Aucun plan actif",
  "dialogs.global.no_role.description":
    "Veuillez passer à un plan pour continuer.",
  "dialogs.global.blocked_ip.title": "Votre IP est bloquée",
  "dialogs.global.blocked_ip.description": "Veuillez contacter le support.",
  "dialogs.global.rate_limit.title": "Limite de débit dépassée",
  "dialogs.global.rate_limit.description":
    "Vous pouvez passer à un plan Pay Per Use pour un accès illimité.",
  "dialogs.global.disk_full.title": "Le stockage est plein",
  "dialogs.global.disk_full.description":
    "Veuillez libérer de l'espace pour continuer à utiliser Youka.",
  "dialogs.global.too_big.title": "Le fichier audio dépasse la taille limite.",
  "dialogs.global.too_big.description":
    "Attention, le fichier audio ne peut excéder une durée maximale de 15 minutes.",
  Help: "Aide",
  Original: "Original",
  Sort: "Trier",
  "sort.date.asc": "Date de création (du plus ancien au plus récent)",
  "sort.date.desc": "Date de création (du plus récent au plus ancien)",
  "sort.title.asc": "Titre (A à Z)",
  "sort.title.desc": "Titre (Z à A)",
  Start: "Début",
  End: "Fin",
  Time: "Temps",
  "dialogs.trim.title": "Couper",
  "dialogs.trim.description":
    "Utilisez la bordure ajustable sur la forme d'onde pour choisir la partie de la chanson que vous souhaitez conserver.",
  Related: "Lié",
  preserve_vocals: "Préserver les Voix",
  preserve_vocals_description:
    "Activez ceci pour préserver les voix comme les chœurs.",
  "Separate Audio": "Séparer l'Audio",
  "Separate Model": "Modèle de Séparation",
  "Add Lyrics": "Ajouter des Paroles",
  "Background Image or Video": "Image ou Vidéo de Fond",
  Docs: "Docs",
  Watch: "Regarder",
  Hide: "Cacher",
  "watch.sync.title":
    "Comment réparer facilement la synchronisation des paroles ?",
  "watch.sync.url": "https://www.youtube.com/watch?v=DFP7SXAWETQ",
  Review: "Avis",
  "watch.review.title": "Donnez votre avis sur Youka sur Trustpilot",
  "Import Subtitles": "Importer des Sous-titres",
  Import: "Importer",
  "How to use": "Comment utiliser",
  Uppercase: "Majuscule",
  "Open Dual Screen": "Ouvrir l'Ecran Duplicata",
  "Close Dual Screen": "Fermer l'Ecran Duplicata",
  "Import Karaoke File": "Importer un Fichier Karaoké",
  "dialogs.import_karaoke.title": "Importer le Karaoké depuis un Fichier",
  "dialogs.import_karaoke.description":
    "Importez un fichier karaoké existant, comme un MP3/MP4 avec paroles intégrées, un fichier LRC avec le même nom, ou un fichier Karafun.",
  optional: "optionnel",
  "Trial Expired": "Essai Expiré",
  "Subtitles Settings": "Paramètres des Sous-titres",
  Milliseconds: "Millisecondes",
  Seconds: "Secondes",
  Text: "Texte",
  Enabled: "Activé",
  Duration: "Durée",
  Gap: "Gap",
  Offset: "Décalage",
  "Min Duration": "Durée Minimale",
  "Max Duration": "Durée Maximale",
  "Fade In": "Fade In",
  "Fade Out": "Fade Out",
  "plugins.title.title": "Titre de la chanson",
  "plugins.title.description":
    "Insérez le titre de la chanson au début de la vidéo",
  "plugins.gap_text.title": "Texte de Gap Silencieux",
  "plugins.gap_text.description":
    "Insérez le texte dans le gap entre les sous-titres",
  "plugins.gap_progress_bar.title": "Barre de Progression de Gap Silencieux",
  "plugins.gap_progress_bar.description":
    "Insérez une barre de progression dans le gap entre les sous-titres",
  "plugins.fade.title": "Effet de Fade",
  "plugins.fade.description":
    "Ajoutez l'effet de fade in et fade out aux sous-titres",
  "plugins.offset.title": "Décalage",
  "plugins.offset.description":
    "Décalez les sous-titres d'une certaine quantité de secondes",
  "plugins.countdown.title": "Compte à Rebour de Gap Silencieux",
  "plugins.countdown.description":
    "Insérez un compte à rebours dans le gap entre les sous-titres",
  Auto: "Automatique",
  Subword: "Sous-mot",
  Countdown: "Compte à Rebour",
  "Restart required": "Redémarrer requis",
  "Reindex Library": "Reindexer la Bibliothèque",
  "Create playlist": "Créer une playlist",
  "Are you sure you want to delete?": "Êtes-vous sûr de vouloir supprimer?",
  "Add to playlist": "Ajouter à la playlist",
  "New playlist": "Nouvelle playlist",
  "Remove from this playlist": "Supprimer de cette playlist",
  Songs: "Chansons",
  Playlists: "Playlists",
  Name: "Nom",
  Photo: "Photo",
  "No playlists": "Aucune playlist",
  "Welcome to Youka": "Bienvenue sur Youka",
  "Search songs online": "Rechercher des chansons en ligne",
  "create.file.title": "Créer un karaoké à partir d'un fichier",
  "create.file.description":
    "Téléchargez votre fichier MP3, MP4 ou d'autres formats pour créer instantanément une vidéo de karaoké avec paroles synchronisées.",
  "create.online.title": "Créer un karaoké à partir de chansons en ligne",
  "create.online.description":
    "Recherchez des chansons en ligne ou collez une URL de chanson pour créer instantanément une vidéo de karaoké avec paroles synchronisées.",
  "Change Background": "Changer le Fond",
  "Duet Line Split": "Diviser la Ligne de Duet",
  Both: "Les Deux",
  Custom: "Personnalisé",
  Edited: "Edité",
  Trimmed: "Couper",
  Instrumental: "Instrumental",
  "Add Subword": "Ajouter un Sous-mot",
  "plugins.max_chars.title": "Caractères maximum par ligne",
  "plugins.max_chars.description": "Limiter le nombre de caractères par ligne",
  Limit: "Limite",
  "Background Box": "Boîte de Fond",
  Height: "Hauteur",
  Width: "Largeur",
  Alpha: "Alpha",
  Color: "Couleur",
  Duplicate: "Dupliquer",
  "Convert to 16x9": "Convertir en 16x9",
  "Resize Video": "Redimensionner la Vidéo",
  "Line Alignment": "Alignement de Ligne",
  "Shadow Color": "Couleur de Ombres",
  "Outline Color": "Couleur de Contour",
  "Active Color": "Couleur Active",
  "Secondary Color": "Couleur Secondaire",
  "Primary Color": "Couleur Primaire",
  "Auto Alignment": "Alignement Automatique",
  "Auto Color": "Couleur Automatique",
  "Singer 1": "Chanteur 1",
  "Singer 2": "Chanteur 2",
  "Top Row": "Ligne Supérieure",
  "Bottom Row": "Ligne Inférieure",
  "Border Style": "Style de Bordure",
  "Font Name": "Nom de la Police",
  "Experimental Subtitles Display": "Affichage des Sous-titres Expérimentaux",
  Position: "Position",
  "Timing Indicator": "Indicateur de Temps",
  General: "Général",
  Styles: "Styles",
  Thumbnail: "Miniature",
  "create.url.title": "Créer un Karaoké à partir d'une URL",
  "create.url.description":
    "Créer un karaoké à partir d'une URL compatible avec yt-dlp",
  "Paste a URL or start typing to search":
    "Collez une URL ou commencez à taper pour rechercher",
  Top: "Haut",
  Bottom: "Bas",
  Center: "Centre",
  "Auto Line Break": "Diviser la Ligne Automatiquement",
  "Fill Color": "Couleur de Remplissage",
  "Active Line Color": "Couleur de Ligne Active",
  "Waiting Line Color": "Couleur de Ligne en Attente",
  "Set as Default": "Définir comme Prédéfini",
  Default: "Prédéfini",
  "Make Default": "Définir par défaut",
  Image: "Image",
  Pause: "Pause",
  File: "Fichier",
  "Debug Info": "Informations de Débogage",
  "File Type": "Type de Fichier",
  Language: "Langue",
  "Reset Settings": "Réinitialiser les Paramètres",
  "Failed to start Youka": "Erreur lors du démarrage de Youka",
  Legacy: "Traditionnel",
  Transcription: "Transcription",
  Alignment: "Alignement",
  Imported: "Importé",
  "With Backing Vocals": "Avec Chœurs",
  Stem: "Stem",
  Clear: "Effacer",
  "Open Directory": "Ouvrir le Dossier",
  "Advanced Settings": "Paramètres Avancés",
  "How to Add a Background Black Box to Subtitles":
    "Comment ajouter une boîte noire en arrière-plan aux sous-titres",
  "How to Adjust the Line Length": "Comment ajuster la longueur des lignes",
  "How to Cancel Your Subscription": "Comment annuler votre abonnement",
  "How to Center Subtitles": "Comment centrer les sous-titres",
  "How to Delete a Karaoke": "Comment supprimer un karaoké",
  "How to Edit the lyrics": "Comment modifier les paroles",
  "How to Fix the Sync": "Comment corriger la synchronisation",
  "How to Keep Choirs": "Comment conserver les chœurs",
  "How to Keep the Original Singer’s Voice":
    "Comment conserver la voix originale du chanteur",
  "How to Set Up a Duet": "Comment configurer un duo",
  "How to Speed Up the Download Process":
    "Comment accélérer le processus de téléchargement",
  "How to Transfer Your Karaoke Library to a New Computer":
    "Comment transférer votre bibliothèque de karaoké vers un nouvel ordinateur",
  "How to Trim a Karaoke Video": "Comment découper une vidéo de karaoké",
  FAQ: "FAQ",
  "library.description":
    "Accédez et gérez toutes les pistes de karaoké que vous avez créées. Modifiez, organisez et perfectionnez vos projets.",
  "How to Change the Background Video": "Comment changer le vidéo de fond",
  "Auto Size": "Taille Automatique",
  "dialogs.global.no_credits.title": "Aucun crédit disponible",
  "dialogs.global.no_credits.description":
    "Veuillez recharger des crédits pour continuer",
  "Credits are over! Click to buy more":
    "Les crédits sont épuisés ! Cliquez pour en acheter plus",
  "How to Add a Line Break": "Comment ajouter un saut de ligne",
  "dialogs.global.no_user.many_emails_description":
    "L'accès a été bloqué en raison de multiples connexions utilisant différentes adresses e-mail. Veuillez acheter un abonnement pour continuer.",
  "dialogs.global.no_user.virtual_machine_description":
    "L'accès a été bloqué car vous utilisez une machine virtuelle. Pour accéder à l'essai gratuit, veuillez installer Youka sur un système d'exploitation standard. Si vous avez un abonnement, veuillez le renouveler pour rétablir l'accès. Si vous n'avez pas besoin de générer du karaoké en continu, vous pouvez opter pour un plan de paiement à l'utilisation, ce qui garantit que vous ne payez que lorsque vous créez un nouveau contenu de karaoké.",
  "Import Stem": "Importer le Stem",
  "Active Outline Color": "Couleur de Contour Active",
  "Inactive Outline Color": "Couleur de Contour Inactive",
  "Inactive Line Color": "Couleur de Ligne Inactive",
  "Active Line": "Ligne Active",
  "Inactive Line": "Ligne Inactive",
  "End Extra": "Extra à la fin",
  Expand: "Développer",
  Collapse: "Réduire",
  "Copy Line": "Copier la ligne",
  "Copy Word": "Copier le mot",
  "Cut Line": "Couper la ligne",
  "Cut Word": "Couper le mot",
  "Delete Line": "Supprimer la ligne",
  "Delete Subword": "Supprimer le sous-mot",
  "Delete Word": "Supprimer le mot",
  "Add Line": "Ajouter une ligne",
  "Add Word": "Ajouter un mot",
  // "Add Subword": "Ajouter un sous-mot",
  "Paste Line": "Coller la ligne",
  "Paste Word": "Coller le mot",
  "Paste Subword": "Coller le sous-mot",
  "Play Line": "Lire la ligne",
  "Play Word": "Lire le mot",
  "Select Line": "Sélectionner la ligne",
  "Manual Sync": "Synchronisation manuelle",
  "Trim Start": "Couper le début",
  "Trim End": "Couper la fin",
  "Creating will use 1 credit": "La création utilisera 1 crédit",
  All: "Tous",
  "Number of Singers": "Nombre de chanteurs",
  "Style Mapping": "Association de styles",
  "Associate subtitle styles with singers":
    "Associer les styles de sous-titres aux chanteurs",
  "Upper first line": "Première ligne supérieure",
  "Upper second line": "Deuxième ligne supérieure",
  "Lower first line": "Première ligne inférieure",
  "Lower second line": "Deuxième ligne inférieure",
  Lock: "Verrouiller",
  "2 Lines": "2 lignes",
  "4 Lines": "4 lignes",
  Static: "Statique",
  Dynamic: "Dynamique",
  "Subtitles Type": "Type de sous-titres",
  "Danger Zone": "Zone Dangereuse",
  Copy: "Copier",
  Copied: "Copié",
  "Copy Settings": "Copier les Paramètres",
  "cta.social.title": "Obtenez 50 crédits GRATUITS !",
  "cta.social.description":
    "Partagez un post sur Youka sur les réseaux sociaux, identifiez-nous et gagnez 50 crédits gratuits par plateforme !",
  "cta.social.description.2":
    "Cliquez pour visiter la page Facebook de Youka, aimez-la, partagez une publication et envoyez votre e-mail dans le chat pour recevoir 50 crédits gratuits !",
  "Merge Line": "Fusionner la ligne",
  Player: "Lecteur",
  "Key Step": "Étape de tonalité",
  "Tempo Step": "Étape de tempo",
  "Shift Line Forward": "Décaler la ligne vers l'avant",
  "Shift Line Backward": "Décaler la ligne vers l'arrière",
  "create.description":
    "Créez un karaoké à partir de fichiers audio ou vidéo (MP3, MP4 et plus), ou collez une URL pour générer instantanément une vidéo de karaoké avec des paroles synchronisées.",
  "No file chosen": "Aucun fichier choisi",
  "Choose File": "Choisir un fichier",
  "Watch Quick Start Video": "Regarder la vidéo de démarrage rapide",
  "Export Settings": "Exporter les paramètres",
  "Import Settings": "Importer les paramètres",
  "Video Guides": "Guides de vidéo",
  "Quick Start Guide": "Guide de démarrage rapide",
  "Lyrics Sync Guide": "Guide de synchronisation des paroles",
  Resolution: "Résolution",
  "Subtitles Preset": "Préréglage des sous-titres",
  Preset: "Préréglage",
  Done: "Terminé",
  "New Style Mapping": "Nouvelle correspondance de style",
  Horizontal: "Horizontal",
  Vertical: "Vertical",
  Square: "Carré",
  New: "Nouveau",
  "New Subtitles Preset": "Nouveau préréglage des sous-titres",
  "Change Aspect Ratio": "Changer le rapport d'aspect",
  "copyright.title.a": "J'accepte la",
  "copyright.title.b": "Confirmation d'utilisation de la musique",
  "copyright.description":
    "En cochant cette case, vous confirmez que (A) vous détenez tous les droits sur la musique incluse dans cette vidéo ; ou (B) la musique est dans le domaine public ; ou (C) vous avez l'autorisation de tous les titulaires de droits nécessaires pour utiliser la musique sur la plateforme Youka.",
  "Add Intro Video": "Ajouter une vidéo d’introduction",
  "dialogs.intro.description":
    "Ajoutez une vidéo personnalisée au début du karaoké",
  Transition: "Transition",
  Fade: "Fondu",
  "Circle Open": "Ouverture en cercle",
  "Circle Close": "Fermeture en cercle",
  "Diagonal Open": "Ouverture diagonale",
  "Diagonal Close": "Fermeture diagonale",
  "Smooth Left": "Lisse vers la gauche",
  "Smooth Right": "Lisse vers la droite",
  Squares: "Carrés",
  Dissolve: "Dissolution",
  Type: "Type",
  "Song Title": "Titre de la chanson",
  Artists: "Chanteurs",
  Artist: "Chanteur",
  "Parse Titles": "Analyser les titres",
  "sort.artist.asc": "Chanteur (A à Z)",
  "sort.artist.desc": "Chanteur (Z à A)",
  "Title Style": "Style de titre",
  "Artist Style": "Style de chanteur",
  "Analyse Library": "Analyser la bibliothèque",
  "No Filter": "Aucun filtre",
  "credits.message_one": "Cela utilisera {{count}} crédit",
  "credits.message_other": "Cela utilisera {{count}} crédits",
  "credits.badge_one": "{{count}} crédit",
  "credits.badge_other": "{{count}} crédits",
  "Provide song lyrics to save credits":
    "Ajoutez des paroles de chansons pour économiser des crédits",
  "Upload to Cloud Library": "Téléverser dans la bibliothèque cloud",
  "Cloud Library": "Bibliothèque cloud",
  "Open Cloud Library": "Ouvrir la bibliothèque cloud",
};
